module.exports = __webpack_public_path__ + "static/img/news_top_02_1.b9dbe679.gif";